export function getChangelogBreadcrumbTitle({
	translationTitle,
	changelogTitle,
}: {
	translationTitle?: string | null
	changelogTitle?: string | null
}): string {
	return translationTitle || changelogTitle || "New changelog"
}
